import Vue from 'vue'
import Vuex from 'vuex'
import dailog from './modules/dailog'
Vue.use(Vuex);
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
const store = new Vuex.Store({
    state: {
    },
    mutations: {
        setUsername(state, username) {
            Vue.$cookies.set('username', username, '1d');
            localStorage.setItem("username",username);
            localStorage.setItem("time",new Date());
        },
        setUserid(state, userid) {
            Vue.$cookies.set('userid', userid, '1d');
        },
        setToken(state, token) {
            Vue.$cookies.set('token', token, '1d');
        }
    },
    actions: {
        setCleanUp() {
            Vue.$cookies.remove('username');
            Vue.$cookies.remove('userid');
            Vue.$cookies.remove('token');
            localStorage.clear();
        }
    },
    modules:{
        dailog
    }
});
export default store;
